<template>
  <span :class="[$style['swtich-wrapper'], disabled ? $style['swtich-wrapper--disabled'] : []]">
    <label :class="$style['switch']">
      <span :class="$style['switch-inner']" />
      <input
        :checked="checked"
        type="checkbox"
        @click="$emit('onChecked', $event.target.checked)"
      >
      <span :class="$style['slider']" />
      <span
        :class="[$style['label-text'], checked ? $style['label-text--active'] : []]"
        class="ds-checkbox-switch-label-text"
      >
        <slot name="text" />
      </span>
    </label>
  </span>
</template>

<script>
export default {
  name: "DsCheckboxSwitch",
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" module>
@import "../../scss/_variables.scss";

$width: 32px;
$height: 1.43em;
$circle-size: 0.84em;
$move: 12px;
$transition: 0.25s;

.swtich-wrapper {
  display: flex;
  align-items: center;
  line-height: $height;
  font-size: $font-regular-size;
  &--disabled {
    pointer-events: none;
    opacity: 0.3;
    filter: grayscale(2);
  }
}
.switch-inner {
  position: relative;
  display: inline-block;
  width: $width;
  height: $height;
}
.switch {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.switch input {
  display: none;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  -webkit-transition: $transition;
  transition: $transition;
  border-radius: $height;
  border: 2px solid $navy-blue-color;
  width: $width;
}
.slider:before {
  position: absolute;
  content: "";
  height: $circle-size;
  width: $circle-size;
  left: 2px;
  bottom: 2px;
  background-color: $navy-blue-color;
  -webkit-transition: $transition;
  transition: $transition;
  border-radius: 50%;
}
input:checked + .slider {
  transition: $transition;
  border: 2px solid $light-green-color;
  &:before {
    background-color: $light-green-color;
  }
}
input:checked + .slider:before {
  -webkit-transform: translateX($move);
  -ms-transform: translateX($move);
  transform: translateX($move);
}
.label-text {
  margin-left: 10px;
  color: $light-gray-color;
  transition: $transition;
  &--active {
    transition: $transition;
    color: $black-blue-color;
  }
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-checkbox-switch.vue